module.exports = __webpack_public_path__ + "img/02572512000662.d89dbe87.png";